import { DataRequestProject } from '../models/DataRequestHub/DataRequestProject';
import { ProjectProgressStatus } from '../models/DataRequestHub/ProjectProgressStatusEnum copy';

export const useIsDataRequestProjectReadonly = (
    projects: DataRequestProject[],
    engagementId?: number
): boolean =>
    projects.length > 0 &&
    projects.every(
        (project) =>
            project?.isExternalProject &&
            project?.status === ProjectProgressStatus.Complete
    );
